<template>
  <vx-card title="Loan Name">
    <div id="user-edit-tab-info">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full mb-base">
            <template>
              <vs-table
                stripe
                max-items="8"
                pagination
                search
                :data="getLoanName"
              >
                <template slot="thead">
                  <vs-th>Id</vs-th>
                  <vs-th>Code</vs-th>
                  <vs-th>Description</vs-th>
                  <vs-th>Loan Type</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].loanNameId">
                      {{ data[indextr].loanNameId }}
                    </vs-td>
                    <vs-td :data="data[indextr].loanNameCode">
                      {{ data[indextr].loanNameCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].loanName">
                      {{ data[indextr].loanName }}
                    </vs-td>
                    <vs-td :data="data[indextr].loanTypeId">
                      {{ loanType(data[indextr].loanTypeId).loanTypeName }}
                    </vs-td>

                    <vs-td>
                      <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                        <feather-icon
                          icon="Edit3Icon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="editRecord(data[indextr].loanNameId)"
                        />
                        <feather-icon
                          icon="Trash2Icon"
                          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                          @click="confirmDeleteRecord(data[indextr].loanNameId)"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </template>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            type="gradient"
            color="primary"
            @click="promptAddNewRecord()"
            icon-pack="feather"
            icon="icon-plus"
            >Add</vs-button
          >
        </div>
      </div>
      <!-- ADD LOAN NAME -->
      <vs-prompt
        class="email-compose"
        title="Add Loan Name"
        accept-text="Submit"
        @accept="onAddNewRecord"
        :is-valid="validForm"
        :active.sync="activePromptAddRecord"
      >
        <vx-card title="Please fill-out the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="loanName.loanNameCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="loanName.loanName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Loan Type</span
              ><span style="color: red">*</span>
              <v-select
                name="Loan Type"
                v-validate="'required'"
                class="w-full"
                v-model="loanTypeName"
                label="loanTypeName"
                :options="getLoanType"
                placeholder="Please Select"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Loan Type')"
                >{{ errors.first("Loan Type") }}</span
              >
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END ADD LOAN NAME -->

      <!-- EDIT LOAN NAME -->
      <vs-prompt
        class="email-compose"
        title="Edit Loan Name"
        accept-text="Submit"
        @accept="onUpdateRecord"
        :is-valid="validForm"
        :active.sync="activePromptEditRecord"
      >
        <vx-card title="You may update the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="loanName.loanNameCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="loanName.loanName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Loan Type</span
              ><span style="color: red">*</span>
              <v-select
                name="Loan Type"
                v-validate="'required'"
                class="w-full"
                v-model="loanTypeName"
                label="loanTypeName"
                :options="getLoanType"
                placeholder="Please Select"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Loan Type')"
                >{{ errors.first("Loan Type") }}</span
              >
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END EDIT LOAN NAME  -->
    </div>
  </vx-card>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loanName: {
        loanNameCode: "",
        loanNameName: "",
        loanTypeId: 0,
      },
      activePromptAddRecord: false,
      activePromptEditRecord: false,
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllLoanName").catch((err) => {
      console.log(err);
    });
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    getLoanName() {
      return this.$store.state.lookup.getAllLoanName;
    },
    getLoanType() {
      return this.$store.state.lookup.getAllLoanType;
    },
    loanTypeName: {
      get() {
        return this.$store.getters["lookup/loanTypeLookup"](
          this.loanName.loanTypeId
        );
      },
      set(obj) {
        this.loanName.loanTypeId = obj.loanTypeId;
      },
    },
    loanType() {
      return (id) => this.$store.getters["lookup/loanTypeLookup"](id);
    },
    validForm() {},
  },
  methods: {
    promptAddNewRecord() {
      this.activePromptAddRecord = true;
    },
    onAddNewRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/addLoanName", this.loanName)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Save Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
    editRecord(id) {
      const e = this.$store.getters["lookup/loanNameLookup"](id);

      (this.loanName.loanNameId = id),
        (this.loanName.loanNameCode = e.loanNameCode),
        (this.loanName.loanName = e.loanName),
        (this.activePromptEditRecord = true);
    },
    onUpdateRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/updateLoanName", this.loanName)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Updated Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
  },
};
</script>
